import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { MainNav, TopNav } from "../components/Header"
import Footer from "../components/Footer"
import "../theme/global.less"

export default function Layout({ children }) {
  const { settings } = useStaticQuery(graphql`
    query themeQuery {
      settings {
        theme {
          background_color
        }
      }
    }
  `)
  const theme = settings.theme.background_color
  return (
    <>
      <TopNav
        className="hide-mobile"
        address="Gedung Danadyaksa Cikini, Jl. Cikini Raya No.91A-D, Menteng, Jakarta Pusat"
        phone="1500-652"
        theme={theme}
      />
      <MainNav />

      <React.Fragment>{children}</React.Fragment>

      <Footer theme={theme} />
    </>
  )
}
